import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React, {useEffect, useState} from "react";
import "react-datepicker/dist/react-datepicker.css";
import {Controller, useFieldArray, useForm} from "react-hook-form";
//import slices
import {useDispatch, useSelector} from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import {languageLevels} from "../../../db/models/const";
import {languages as languagesDataset} from "../../../db/datasets/languages";
import {closeDialog} from "../../../slices/dialog";
import {addRmLanguage, updateRmLanguage} from "../../../api/common";
import "../../CommonComponents.scss";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import {selectSelectedRm} from "../../../slices/selected";
import {sanitizeUrl} from "../../../helpers/misc";
import {useTranslation} from "react-i18next";

export const EditRmLanguage = ({language}) => {
    const {register, handleSubmit, control} = useForm({
        defaultValues: {
            labelId: language?.labelId || 0,
            levelId: language?.levelId || 0,
            certificate: language?.certificate || "",
            optional: language?.importance === 2 ? true : false
        },
    });
    const {fields, append, remove} = useFieldArray({
        control,
        name: "materials"
    });
    const [loading, setLoading] = useState(false);
    const rm = useSelector(selectSelectedRm);
    const docId = rm?.id;
    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        if (!language) return;

        if (language.materials)
            append(Object.values(language.materials).map(m => {
                return {id: m.id, title: m.title || "", link: sanitizeUrl(m.link)}
            }));
    }, [language]);

    const onSave = (data) => {

        let l = {
            ...language,
            labelId: data.labelId,
            levelId: data.levelId,
            certificate: data.certificate || "",
            importance: data.optional ? 2 : 1
        };

        let matMap = {};
        (data.materials || []).map(m => matMap[m.id] = {...m, link: sanitizeUrl(m.link)});
        l.materials = matMap;

        setLoading(true);
        if (language == null) {
            addRmLanguage(docId, l).then(() => {
                setLoading(false);
                dispatch(closeDialog());
            })
                .catch((error) => setLoading(false));
        } else {
            updateRmLanguage(docId, l)
                .then(() => {
                    setLoading(false);
                    dispatch(closeDialog());
                })
                .catch((error) => setLoading(false));
        }
    };

    return (
        <div className="editBgLanguage bg-dialog">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_rm_editLang_language_label")}</div>
                    <Controller
                        render={({onChange, ...props}) => (
                            <Select
                                fullWidth
                                {...props}
                                onChange={(e) => onChange(e.target.value)}
                            >
                                {languagesDataset.map((x) => (
                                    <MenuItem key={x.id} value={x.id}>
                                        {x.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                        name={"labelId"}
                        rules={{required: true}}
                        control={control}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editLang_level_label")}</div>
                    <Controller
                        render={({onChange, ...props}) => (
                            <Select
                                fullWidth
                                {...props}
                                onChange={(e) => onChange(e.target.value)}
                            >
                                {languageLevels.map((x) => (
                                    <MenuItem key={x.id} value={x.id}>
                                        {x.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                        name={"levelId"}
                        rules={{required: true}}
                        control={control}
                    />
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editLang_optional_label")}</div>
                    <div className="checkbox">
                        <input type="checkbox" name="optional" ref={register}></input>
                        <p>{t("company_rm_editLang_optional_text")}</p>
                    </div>
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editLang_certificate_label")}</div>
                    <input
                        type="text"
                        ref={register}
                        name="certificate"
                        placeholder={t("company_rm_editLang_certificate_ph")}
                    ></input>
                </div>
                <div className="element">
                    <div className="label">{t("company_rm_editLang_material_label")}</div>
                    {fields.map((item, index) => (
                        <div className="material" key={item.id}>
                            <input type="hidden" name={`materials[${index}].id`} ref={register()}
                                   defaultValue={item.id}/>

                            <label>{t("company_rm_editLang_material_title_label")}
                                <spam className="error">*</spam>
                            </label>
                            <input
                                type="text"
                                name={`materials[${index}].title`}
                                ref={register({required: true})}
                                defaultValue={item.title}
                            />
                            <label>{t("company_rm_editLang_material_link_label")}
                                <spam className="error">*</spam>
                            </label>
                            <input
                                type="text"
                                name={`materials[${index}].link`}
                                ref={register({required: true})}
                                defaultValue={item.link}
                            />
                            <button className="remove" onClick={() => remove(index)}>
                                <RemoveIcon/> {t("company_rm_editLang_material_remove")}</button>
                        </div>
                    ))}
                    <button className="add"
                            onClick={() => append({id: Math.random().toString(36).substr(2, 9), title: "", link: ""})}>
                        <AddIcon/> {t("company_rm_editLang_material_add")}
                    </button>
                </div>
                {!loading && <input type="submit" value={t("company_rm_editLang_submit")}></input>}
                {loading && (
                    <div className="loader">
                        <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                    </div>
                )}
            </form>
        </div>
    );
};